import { gql } from 'apollo-boost';

export const allOrgUsersQuery = gql`
  {
    orgUser {
      all {
        id
      }
    }
  }
`;

export const paged = gql`
  query paged($orgId: ID!, $limit: Int!, $offset: Int!) {
    orgUser {
      paged(orgId: $orgId, limit: $limit, offset: $offset) {
        results {
          id
          active
          firstName
          lastName
          email
          roleId
          phone
        }
        totalCount
      }
    }
  }
`;

export const orgUsersByOrgIdQuery = gql`
  query orgUsersByOrgId($orgId: ID!) {
    orgUser {
      all(orgId: $orgId) {
        id
        orgId
        userId
        firstName
        lastName
        phone
        email
      }
    }
  }
`;

export const userRole = gql`
  query userRole($id: ID!) {
    orgUser {
      byId(id: $id) {
        roleId
      }
    }
  }
`;
